/* global: XmlHttpRequest */

var ready = require('./ready.js');

ready(function() {
    var upVoteAnswer = function(e) {
        e.preventDefault();

        var target = this.dataset.target;
        var resultElement = document.querySelector(this.dataset.result);
        var previousValue = parseInt(resultElement.innerHTML, 10);

        // Optimistic UI
        resultElement.innerHTML = previousValue + 1;

        var request = new XMLHttpRequest();
        request.open('POST', target, true);
        request.onreadystatechange = function () {
            if (request.readyState == 4) {
                if (request.status == 200) {
                    resultElement.innerHTML = JSON.parse(this.response).upVoteCount;
                } else {
                    resultElement.innerHTML = previousValue;
                }
            }
        };
        request.send();
    };

    var selector = '.upvote-question';
    var elements = document.querySelectorAll(selector);

    Array.prototype.forEach.call(elements, function(el) {
        el.addEventListener('click', upVoteAnswer);
    });
});
